var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BuscaAvancada',{model:{value:(_vm.relatorio_oportunidades.filtros),callback:function ($$v) {_vm.$set(_vm.relatorio_oportunidades, "filtros", $$v)},expression:"relatorio_oportunidades.filtros"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }